import { Button, Stack, Typography } from "@altimateai/lego";
import { SuccessMultiIcon } from "@/assets/icons";

interface RegenerateSuccessProps {
  toggleShow: () => void;
}

const RegenerateSuccess = ({ toggleShow }: RegenerateSuccessProps) => {
  return (
    <Stack
      role="status"
      className="al-bg-contextual-mint-green al-p-2 al-rounded-sm al-mb-4"
      justify="between"
    >
      <Stack justify="start">
        <SuccessMultiIcon />
        <div>
          <Typography variant="subheading">
            Your API key has been regenerated successfully
          </Typography>
          <Typography variant="body">
            Please update your Altimate CLI and Extension with the new API key.
          </Typography>
        </div>
      </Stack>
      <div>
        <Button variant="ghost" size="icon" title="Close" onClick={toggleShow} aria-label="Close">
          ✕
        </Button>
      </div>
    </Stack>
  );
};

export default RegenerateSuccess;
